/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeTimeframe, getRecsDashboard } from 'actions';
import DateRangePicker from 'components/kea/DateRangePicker';
import FeaturePageShell from 'components/shell/FeaturePageShell';
import { matchDatesDashboardCase } from 'util/appUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import Summary from './Summary';
import Audience from './Audience';
import CartProducts from './CartProducts';
import Conversion from './Conversion';
import AdditionalProfit from './AdditionalProfit';
import AverageOrder from './AOV';
import AverageViews from './AverageViews';
import Profitability from './Profitability';
import styles from './RecsDashboard.module.scss';

const Dashboard = () => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const {
    analytics: { recs, timeframe },
    app: { currentShop },
  } = useSelector((store) => store);
  const { dashboard: { isFetching, projection, meta, error } } = recs;

  useEffect(() => {
    const dataIsUnavailable = !isFetching && currentShop;
    const datesIsMatched = meta && matchDatesDashboardCase(meta, timeframe);
    if (dataIsUnavailable || !datesIsMatched) dispatch(getRecsDashboard(currentShop, timeframe));
  }, [timeframe, currentShop]);

  const onTimeframeSubmit = (newRange) => dispatch(changeTimeframe(newRange));

  const timeframePicker = (
    <DateRangePicker
      timeframe={timeframe}
      onSubmitRange={onTimeframeSubmit}
    />
  );

  return (
    <FeaturePageShell
      title={localizeMessage('recs.dashboard.header')}
      description={localizeMessage('recs.dashboard.description')}
      width="expanded"
      actions={timeframePicker}
      isLoading={isFetching}
      error={error}
      onRetry={() => dispatch(getRecsDashboard(currentShop, timeframe))}
    >
      {projection && (
        <div className={styles.dashboard} data-testid="recommendation-dashboard">
          <Summary summary={projection.summary} />

          <div className={styles.cardGrid}>
            <Audience audience={projection.audience} />
            <CartProducts withProducts={projection.withProducts} />
            <Conversion conversion={projection.conversion} />
            <AdditionalProfit money={projection.money} />
            <AverageOrder aov={projection.aov} />
            <AverageViews averageViews={projection.averageViews} />
          </div>

          <div className={styles.trendCard}>
            <Profitability chart={projection.chart} />
          </div>
        </div>
      )}
    </FeaturePageShell>
  );
};

export default Dashboard;
